//
//
//
//
//
//
//
//
//
//
//

import uniIcon from "@/components/uni-icon/uni-icon.vue"
export default{
  data () {
    return {
      idCard: '',
      loading:false,
      iconShow:false
    }
  },
  components:{uniIcon},
  watch:{
    idCard(val,old){
      if(val.length>0){
        this.iconShow = true
      } else {
        this.iconShow = false
      }
    }
  },
  onLoad () {
    this.queryData()
  },
  methods: {
    id(e){
      this.idCard = e.target.value
    },
    //内容清空
    clearContent(){
      this.idCard = ''
    },
    //获取信息
    queryData () {
      let _this = this
      this.$ajax({
        method: 'post',
        url: '/weChat/member/queryById',
        data: {
          memberId: this.$store.state.userInfo.id
        },
        success(res){
          _this.idCard = res.data.idCard
        }
      })
    },
    //更新
    update () {
      let _this = this
      if (_this.testID(_this.idCard) || !_this.idCard) {
         _this.loading = true
        this.$ajax({
          method: 'post',
          url: '/weChat/member/updateById',
          data: {
            memberId: this.$store.state.userInfo.id,
            idCard: _this.idCard
          },
          success(res){
            _this.loading = false
            uni.navigateBack({
              delta: 1
            })
          }
        })
      } else {
        uni.showToast({
          title: '身份证格式不正确!',
          icon: 'none'
        })
      }
    },
    testID () {
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.idCard)
    },
  }
}
